import { InferValueTypes } from '@quiz-frontend/quiz-builder/types/store-types';

import { ImageEntity } from '../../types/image';
import { Question } from '../../types/question';
import * as actions from './actions';

export enum QuizStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export enum StepLayouts {
  SIMPLE = 'simple',
  COMPLEX = 'complex',
  SIGNIN = 'signin',
  ROWS = 'rows',
  FORM = 'form',
}

export interface Quiz {
  id: string;
  name: string;
  welcomeText: string;
  description: string;
  steps: Step;
}

export interface NewStep {
  currentStep: Step;
  prevStepSlug: string;
  nextStepSlug?: string;
  lastStepSlug: string;
  currentNumber: number;
  totalNumber: number;
}

export interface Step {
  id?: string;
  slug: string;
  title: string;
  quizId: string;
  stepImages?: {
    stepId: string;
    imageId: string;
    image?: ImageEntity;
    position?: number;
  }[];
  layout: StepLayouts;
  questions: Question[];
}

export interface QuestionConstriant {
  optionId: string;
  parentId: string;
}

export type QuizValue = string | string[];

export interface QuizValues {
  [key: string]: QuizValue;
}

export type Palette = Array<{
  fill: string;
  border: string;
}>;

export type QuizActionTypes = ReturnType<InferValueTypes<typeof actions>>;
